const style = {
    border: {
        display: "flex",
        justifyContent: "row",
        height: "100vh",
        backgroundColor: "background.main"
    },
    childrenBorder: {
        width: "100%",
        overflow: "scroll",
        paddingBottom: "40px"
    }
}

export default style;